/** Ponte para navegação SPA fora de componentes React (ex.: helpers de popup). */
let appNavigateFn = null;

export function registerAppNavigate(fn) {
  appNavigateFn = typeof fn === "function" ? fn : null;
}

export function appNavigate(to, options) {
  if (appNavigateFn) {
    appNavigateFn(to, options);
    return true;
  }
  if (typeof window !== "undefined" && typeof to === "string" && to) {
    window.location.assign(to);
    return true;
  }
  return false;
}
